export enum AccountStatusEnum {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	SUSPENDED = 'suspended',
	BANNED = 'banned',
	DELETED = 'deleted',
	PENDING = 'pending',
	REJECTED = 'rejected',
}

export enum FrequencyEnum {
	DAILY = 'daily',
	WEEKLY = 'weekly',
	MONTHLY = 'monthly',
	QUARTERLY = 'quarterly',
	ANNUALLY = 'annually',
	NEVER = 'never',
}

export enum GenderEnum {
	MALE = 'male',
	FEMALE = 'female',
}

export enum IdTypeEnumForSearchEnum {
	AGENT = 'agent',
	BRANCH = 'branch',
	CUSTOMER = 'customer',
	DISBURSEMENT = 'disbursement',
	LOAN = 'loan',
	LOAN_OFFER = 'loan_offer',
	PRODUCT = 'product',
	SCHEDULE = 'schedule',
	STAFF_LINK = 'staff_link',
	USER = 'user',
}

export enum VerificationChannelEnum {
	SMS = 'sms',
	EMAIL = 'email',
	WHATSAPP = 'whatsapp',
	SMS_WHATSAPP = 'sms_whatsapp',
}

export enum VerificationTypeEnum {
	RESET = 'reset',
	TFA = '2fa',
	BVN = 'bvn',
	REGISTER = 'register',
}

export enum ErrorResponseEnum {
	TOKEN_NOT_FOUND = 'No authentication token found. Please login again',
	SESSION_EXPIRED = 'Session expired. You have been logged out',
	LOGGED_OUT_DUE_TO_INACTIVITY = 'Logged out due to inactivity',
	INVALID_EMAIL = 'Invalid email address',
	LOGIN_FAILED = 'Login Failed',
	LOGIN_ERROR = 'An error occurred while logging in',
	ERROR_OCCURRED = 'Error Occurred',
	REQUEST_FAILED = 'Request Failed',
	BVN_FIRSTNAME_LASTNAME = "Firstname and Lastname doesn't match with bvn",
	BVN_FIRSTNAME = "Firstname doesn't match with bvn",
	BVN_LASTNAME = "Lastname doesn't match with bvn",
	BVN_DOB = "Date of birth doesn't match with bvn",
	BRANCH_NOT_SET = 'Kindly update your branch to proceed',
	PROFILE_INCOMPLETE = 'Kindly complete your registration before proceeding',
	PENDING_APPROVAL = 'Your account is pending approval',
	REJECTED = 'Your agent account has been rejected',
}

export enum FormValidationEnum {
	EMAIL_REQUIRED = 'Email is required',
	PASSWORD_REQUIRED = 'Password is required',
	TOKEN_NEEDED = 'Please Enter Authenticator Token Value',
	ACTION_CANNOT_BE_REVERSED = 'This action cannot be reverted',
	SURE = 'Are you sure?',
	SURE_FULL = 'Are you sure you want to perform this action?',
	ENTER_NAME = 'Please enter a name',
	FIELD_REQUIRED = 'This field is required',
	ENTER_EMAIL = 'Enter valid email address',
	ENTER_PHONE = 'Please enter a valid phone number',
	PASSWORD_VALIDATION = 'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Character',
	PASSWORD_MATCH = 'Passwords must match',
	VALID_TOKEN = 'Please enter a valid reset token',
	ENTER_URL = 'Enter correct URL',
	ONLY_NUMBERS = 'The field should contain only numbers',
	DESC_TOO_SHORT = 'Description is too short',
	SURE_NEW_KEYS = 'Are you sure you want to generate new API keys?\nThis will remove access from current API Keys request',
}

export enum SuccessResponseEnum {
	TOKEN_CREATED = 'A new verification token has been sent to your email address',
	TOKEN_SENT = 'Token Sent Successfully',
	UPDATED = 'Updated Successfully',
	CREATED = 'Created Successfully',
	ACCOUNT_CREATED = 'You have successfully created your staff account!',
	PASSWORD_CHANGED = 'You have successfully changed your password',
	ACCOUNT_VERIFIED = 'Your account has been verified successfully',
	TOKEN_COPIED = 'Client token copied successfully',
	PROD_KEY_COPIED = 'Production public key copied successfully',
	SANBOX_KEY_COIED = 'Sandbox private / secret key copied successfully',
	DEPOSITED = 'Wallet deposit successful',
	VERIFIED = 'Verified Successfully',
}

export enum LoanStatusEnum {
	Filling = 'Filling',
	Pending = 'Pending',
	Processing = 'Processing',
	Active = 'Active',
	Repaid = 'Repaid',
	Overdue = 'Overdue',
	Declined = 'Declined',
}

export enum LoanTypeEnum {
	NEW_LOAN = 'new-loan',
	TOP_UP = 'toup-up',
}

export enum MaritalStatusEnum {
	MARRIED = 'Married',
	SINGLE = 'Single',
	DIVORCED = 'Divorced',
	WIDOW = 'Widow',
	WIDOWER = 'Widower',
}

export enum TitleEnum {
	MR = 'Mr',
	MRS = 'Mrs',
	DR = 'Dr',
	MISS = 'Miss',
	WIDOWER = 'Widower',
}

export enum RelationshipEnum {
	Spouse = 'Spouse',
	Parent = 'Parent',
	Sibling = 'Sibling',
	Friend = 'Friend',
	Colleague = 'Colleague',
}

export enum AllowMoratoriumEnum {
	False = 'False',
	PrincipalOnly = 'PrincipalOnly',
	InterestOnly = 'InterestOnly',
	PrincipalAndInterest = 'PrincipalAndInterest',
}

export enum MoratoriumEffectEnum {
	IncreaseTotalLoanDuration = 'IncreaseTotalLoanDuration',
	DoNotIncreaseTotalLoanDuration = 'DoNotIncreaseTotalLoanDuration',
}
